'use strict';

var Backbone = require('backbone'),
  config = require('../../js/config'),

  ProjectModel = Backbone.Model.extend({

    idAttribute: 'id',
    urlRoot: config.urls.projects.api,

    defaults: {
      name: ''
    }

  });

module.exports = ProjectModel;



// WEBPACK FOOTER //
// ./assets/components/DesignCenter/projectModel.js